(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = document.querySelectorAll('.sl-section, .sl-product-card, .sl-category-card, .sl-pdp__highlights > div');
  if (!reducedMotion && 'IntersectionObserver' in window) {
    revealItems.forEach((item) => item.classList.add('sl-reveal'));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px' });
    revealItems.forEach((item) => observer.observe(item));
  }
  document.addEventListener('toggle', (event) => {
    const menu = event.target.closest('.sl-mobile-menu');
    if (!menu || !menu.open) return;
    document.querySelectorAll('.sl-mobile-menu[open]').forEach((item) => { if (item !== menu) item.removeAttribute('open'); });
  }, true);
  const galleryTimers = new WeakMap();
  const showGallerySlide = (gallery, index) => {
    const slides = [...gallery.querySelectorAll('.sl-hover-slide')];
    if (!slides.length) return;
    slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
    const count = gallery.querySelector('.sl-gallery-count');
    if (count) count.textContent = `${index + 1} / ${slides.length}`;
  };
  const startGallery = (gallery) => {
    const slides = [...gallery.querySelectorAll('.sl-hover-slide')];
    if (reducedMotion || slides.length < 2 || galleryTimers.has(gallery)) return;
    let index = 0;
    const timer = window.setInterval(() => { index = (index + 1) % slides.length; showGallerySlide(gallery, index); }, 750);
    galleryTimers.set(gallery, timer);
  };
  const stopGallery = (gallery) => {
    const timer = galleryTimers.get(gallery);
    if (timer) window.clearInterval(timer);
    galleryTimers.delete(gallery);
    showGallerySlide(gallery, 0);
  };
  const initializeGalleries = (scope = document) => {
    scope.querySelectorAll('[data-hover-gallery]').forEach((gallery) => {
      if (gallery.dataset.galleryReady) return;
      gallery.dataset.galleryReady = 'true';
      showGallerySlide(gallery, 0);
      gallery.addEventListener('pointerenter', () => startGallery(gallery));
      gallery.addEventListener('pointerleave', () => stopGallery(gallery));
      gallery.addEventListener('focusin', () => startGallery(gallery));
      gallery.addEventListener('focusout', (event) => { if (!gallery.contains(event.relatedTarget)) stopGallery(gallery); });
    });
  };
  initializeGalleries();
  document.addEventListener('shopify:section:load', (event) => initializeGalleries(event.target));
})();
